var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-box"},[_c('div',{staticClass:"detail-title"},[_c('div',{staticClass:"detail-title-big"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_c('div',{staticClass:"detail-title-small"},[_vm._v(_vm._s(_vm.$route.meta.title))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-info"},[_c('div',{staticClass:"detail-info-content",attrs:{"id":"container"}})])
}]

export { render, staticRenderFns }